export default __webpack_public_path__ + "static/media/santa-maria-12.d03cd635.jpg";